// ESF OTOMOTİV - Şirket Bilgileri

export const COMPANY_INFO = {
  name: "ESF OTOMOTİV",
  tagline: "Motor Yenileme Uzmanı",
  foundedYear: 2017,
  experience: "Üretimde modern teknoloji",
  description:
    "ESF Otomotiv, motor rektefiye sektörüne yönelik profesyonel ekipman ve aparatların üretiminde uzmanlaşmış bir mühendislik firmasıdır.",
  longDescription:
    "2017'de pazarlama ile başlayan yolculuğumuzu, 2022'de üretime odaklanarak sürdürdük. CNC makine parkurumuz ve alanında uzman ekibimizle; honlama aparatları, subap yuvası işleme, motor bloğu işleme, özel rektefiye ekipmanları ve makinalarını yüksek hassasiyet ve kalite standartlarında üretiyoruz.",
  contact: {
    phone: ["+90 534 669 00 42"],
    whatsapp: "+90 534 669 00 42",
    email: ["info@esfotomotiv.com", "satis@esfotomotiv.com"],
    address: {
      street: "Fevzi Çakmak Mahallesi",
      address: "Gülistan Caddesi Atiker 3 Sanayi Sitesi No:29/Z",
      city: "Karatay/KONYA",
      country: "Türkiye",
      fullAddress:
        "Fevzi Çakmak Mahallesi Gülistan Caddesi Atiker 3 Sanayi Sitesi No:29/Z Karatay/KONYA",
    },
    workingHours: {
      weekdays: "Pazartesi - Cuma: 08:00 - 18:00",
      saturday: "Cumartesi: 09:00 - 16:00",
      sunday: "Pazar: Kapalı",
    },
  },
  social: {
    facebook: "https://facebook.com/esfotomotiv",
    twitter: "https://twitter.com/esfotomotiv",
    linkedin: "https://linkedin.com/company/esf-otomotiv",
    instagram: "https://instagram.com/esfotomotiv",
    youtube: "https://youtube.com/esfotomotiv",
  },
  features: [
    {
      title: "CNC Üretim Altyapısı",
      description: "Modern CNC parkur ve uzman teknik ekip",
    },
    {
      title: "Geniş Ürün Yelpazesi",
      description: "500+ farklı ürün ve çözüm seçeneği",
    },
    {
      title: "Türkiye Geneli Hizmet",
      description: "Hızlı teslimat ve teknik destek ağı",
    },
    {
      title: "Kalite Garantisi",
      description: "Tüm ürünlerde uluslararası kalite standartları",
    },
  ],
};

export const NAVIGATION_ITEMS = [
  { id: "home", label: "Anasayfa", href: "#hero" },
  { id: "about", label: "Hakkımızda", href: "#about" },
  { id: "products", label: "Ürünler", href: "/products" },
  { id: "services", label: "Hizmetler", href: "#services" },
  { id: "references", label: "Referanslar", href: "#references" },
  { id: "contact", label: "İletişim", href: "#contact" },
];

export const SEO_DATA = {
  title: "ESF OTOMOTİV - Motor Yenileme Uzmanı",
  description:
    "Motor rektefiye sektörüne yönelik profesyonel ekipman ve aparatlar üretiminde uzman mühendislik firması. Honlama aparatları, subap yuvası işleme, motor bloğu işleme, özel rektefiye ekipmanları ve makinalar.",
  keywords:
    "motor yenileme, honlama kafası, kater grupları, motor taşlama, otomotiv ekipman, ESF Otomotiv, motor revizyonu, krank taşlama, subap taşlama",
  author: "ESF OTOMOTİV",
  url: "https://esfotomotiv.com",
};
